<template>
  <div class="agenda-view" data-scroll data-scroll-call="animateMove" :style="{'background': changeColor}">
    <div class="agenda-view-wr">
      <div class="agenda-arr"></div>
      <div class="agenda-ico slidetop" data-scroll data-scroll-call="animateMove">
        <img :src="agendaInfo.cover" alt=""/>
      </div>
      <div class="agenda-info" >
        <div class="agenda-top" v-if="agendaInfo !==undefined">
          <strong class="slidetop" data-scroll data-scroll-call="animateMove">{{agendaInfo.subtitle}}</strong>
          <p class="slidetop detay1" data-scroll data-scroll-call="animateMove">{{agendaInfo.description}}</p>
        </div>
        <div class="agenda-water slidetop detay1" data-scroll data-scroll-call="animateMove">
          <div class="agenda-left" >
            <figure v-if="agendaInfo.publishers !==undefined && agendaInfo.publishers.length > 0">
              <img :src="agendaInfo.publishers[0].smallface" alt=""/>
            </figure>
            <b v-if="agendaInfo.publishers !==undefined && agendaInfo.publishers.length > 0">{{agendaInfo.publishers[0].user}}</b>
            <span v-if="agendaInfo.publishers !==undefined && agendaInfo.publishers.length > 0">出品</span>
          </div>
          <div class="agenda-home"><router-link to="/">返回首页</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      agendaInfo: [],
      changeColor: '#7163F5'
    }
  },
   props: {
    scroll: Object
  },
  methods: {
    async getAgendaInfo () {
      const id = this.$route.params.zone_id
      const { data: res } = await this.$http.get(`zones/${id}`)
      
      if (res.code === 1) {
        this.agendaInfo = res.data
        console.log(this.agendaInfo)
        setTimeout(() => {
          this.scroll.update()
        }, 400)
      }
    },
    changeBackground () {
      const colorIndex = this.$route.query.b
      if(colorIndex == 1) {
        this.changeColor = "#408CFF"
      } else if ( colorIndex == 2) {
        this.changeColor = "#7163F5"
      } else if ( colorIndex == 3){
        this.changeColor = "#00B586"
      }
    }
  },
  mounted () {
    this.getAgendaInfo()
    this.changeBackground()
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/agenda/index.less");
</style>